export async function init () {
  window.location.href = process.env.CHROME_WEBSTORE_URL
}
